document.addEventListener('trix-before-initialize', () => {
  if (!window.Trix) return

  // Heading button should produce a more sensible in-body title size.
  window.Trix.config.blockAttributes.heading1 = {
    ...window.Trix.config.blockAttributes.heading1,
    tagName: 'h2'
  }
  window.Trix.config.lang.heading1 = 'H2'

  // Alignment attributes are persisted with classes (not inline styles),
  // so they survive Action Text sanitization.
  window.Trix.config.blockAttributes.alignLeft = {
    tagName: 'div',
    className: 'trix-align-left',
    parser: (element) => element.classList.contains('trix-align-left')
  }
  window.Trix.config.blockAttributes.alignCenter = {
    tagName: 'div',
    className: 'trix-align-center',
    parser: (element) => element.classList.contains('trix-align-center')
  }
  window.Trix.config.blockAttributes.alignRight = {
    tagName: 'div',
    className: 'trix-align-right',
    parser: (element) => element.classList.contains('trix-align-right')
  }
})

document.addEventListener('trix-initialize', (event) => {
  const editor = event.target
  const toolbar = editor.toolbarElement
  if (!toolbar || toolbar.dataset.alignToolsAdded === 'true') return

  const blockTools = toolbar.querySelector('[data-trix-button-group="block-tools"]')
  if (!blockTools) return

  const group = document.createElement('span')
  group.className = 'trix-button-group trix-button-group--align-tools'
  group.setAttribute('data-trix-button-group', 'align-tools')
  group.innerHTML = `
    <button type="button" class="trix-button trix-button--icon" data-trix-attribute="alignLeft" title="Align left" tabindex="-1">Left</button>
    <button type="button" class="trix-button trix-button--icon" data-trix-attribute="alignCenter" title="Align center" tabindex="-1">Center</button>
    <button type="button" class="trix-button trix-button--icon" data-trix-attribute="alignRight" title="Align right" tabindex="-1">Right</button>
  `

  blockTools.insertAdjacentElement('afterend', group)
  toolbar.dataset.alignToolsAdded = 'true'
})
